"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VM_LOW_OBFUSCATION_PRESET = exports.VM_LOW_OBFUSCATION_PRESET_VM_OPTIONS = void 0;
const OptionsPreset_1 = require("../../enums/options/presets/OptionsPreset");
const NoCustomNodes_1 = require("./NoCustomNodes");
const IdentifierNamesGenerator_1 = require("../../enums/generators/identifier-names-generators/IdentifierNamesGenerator");
const VMBytecodeFormat_1 = require("../../enums/vm-transformers/VMBytecodeFormat");
exports.VM_LOW_OBFUSCATION_PRESET_VM_OPTIONS = {
    vmObfuscation: true,
    vmObfuscationThreshold: 1,
    vmOpcodeShuffle: false,
    vmBytecodeEncoding: false,
    vmBytecodeArrayEncoding: false,
    vmJumpsEncoding: false,
    vmDecoyOpcodes: false,
    vmDeadCodeInjection: false,
    vmSplitDispatcher: false,
    vmMacroOps: false,
    vmDebugProtection: false,
    vmRuntimeOpcodeDerivation: false,
    vmStatefulOpcodes: false,
    vmStackEncoding: false,
    vmRandomizeKeys: false,
    vmIndirectDispatch: false,
    vmBytecodeFormat: VMBytecodeFormat_1.VMBytecodeFormat.Json
};
exports.VM_LOW_OBFUSCATION_PRESET = Object.freeze({
    ...NoCustomNodes_1.NO_ADDITIONAL_NODES_PRESET,
    ...exports.VM_LOW_OBFUSCATION_PRESET_VM_OPTIONS,
    optionsPreset: OptionsPreset_1.OptionsPreset.VMLowObfuscation,
    compact: true,
    simplify: true,
    identifierNamesGenerator: IdentifierNamesGenerator_1.IdentifierNamesGenerator.MangledShuffledIdentifierNamesGenerator
});
